// Notices shown on top of both Courses pages: the courses-project sign-in
// (writes need it; reads are public) and the shared-catalog warning in
// non-prod builds, since one aura-courses project serves every environment.

import { IS_PROD_BUILD } from "../../config/env";
import type { CoursesAuthState } from "../../hooks/useCoursesAuth";

export function CoursesCallouts({ auth }: { auth: CoursesAuthState }) {
  return (
    <>
      {!IS_PROD_BUILD && (
        <div className="callout co-callout">
          This build edits the <strong>live</strong> course catalog in <span className="mono">aura-courses</span>,
          the same one prod Studio and the mobile app use. There is no separate dev catalog.
        </div>
      )}
      {!auth.loading && !auth.user && (
        <div className="callout co-callout co-signin">
          <span>
            <strong>Sign in to edit courses.</strong> The catalog lives in a second Firebase project; you can
            browse it, but saving needs an Aura Google account signed in there too.
          </span>
          <div className="spacer" />
          <button type="button" className="btn btn-primary btn-sm" onClick={auth.signIn} disabled={auth.signingIn}>
            {auth.signingIn ? "Signing in…" : "Sign in to edit courses"}
          </button>
          {auth.error && <span className="error-text">{auth.error}</span>}
        </div>
      )}
    </>
  );
}
